export { default as VisualizarCategoriasCompra } from './VisualizarCategoriasCompra';
